<template>
  <ap-layout class="main-layout" has-sider>
    <ap-sider :width="siderWidth" v-model="value" collapsible>
      <template #header>
        <WorkSpaceHeaderDropdown />
      </template>
      <TheSiderContent />
      <template #footer>
        <TheSiderFooter />
      </template>
    </ap-sider>
    <ap-divider type="vertical" class="h-screen m-0" />
    <ap-layout
      class="main-layout__content"
      :style="{ 'margin-left': !value ? `${siderWidth}px` : '0' }">
      <TheMainLayoutContentHeader
        class="main-layout__content-header"
        @click:menu="menuClickHandler" />
      <TheMainLayoutContentBody
        :class="['main-layout__content-body', { 'w-screen': !value && screens.xs }]">
        <RouterView />
      </TheMainLayoutContentBody>
    </ap-layout>
  </ap-layout>
</template>

<script setup>
import { RouterView, useRoute } from "vue-router"
import { useToggle } from "@vueuse/core"
import { ApGrid } from "@Mobile-Leaves-CORP/ap-components"
import TheSiderFooter from "./TheMainLayoutSiderFooter.vue"
import TheSiderContent from "./TheMainLayoutSiderContent.vue"
import TheMainLayoutContentHeader from "./TheMainLayoutContentHeader.vue"
import TheMainLayoutContentBody from "./TheMainLayoutContentBody.vue"

import { computed, onMounted, onUpdated, ref, watchEffect } from "vue"
import WorkSpaceHeaderDropdown from "@/components/RolesAndUsers/WorkSpaceHeaderDropdown.vue"

const route = useRoute()
const collapsed = computed(() => route.meta.layout?.sidebarCollpased)
const [value, toggle] = useToggle(collapsed.value)
const screens = ApGrid.useBreakpoint()
const siderWidth = ref(0)

function setSiderWidth(value) {
  siderWidth.value = value ? 260 : 0
}

function menuClickHandler() {
  if (value) {
    toggle()
  }
  setSiderWidth(value)
}

watchEffect(() => {
  setTimeout(() => {
    if (collapsed.value) toggle()
  }, 1)
})

onUpdated(() => {
  setSiderWidth(!route.meta.layout?.sidebarCollpased)
})

onMounted(() => setSiderWidth(!route.meta.layout?.sidebarCollpased))
</script>

<style lang="postcss">
.main-layout {
  @apply overflow-hidden max-h-screen;
  .main-layout__content {
    .main-layout__content-header {
      @apply bg-white;
      .ant-input-affix-wrapper input {
        &::placeholder {
          @apply text-black/60;
        }
      }
    }
    .main-layout__content-body {
      @apply bg-white overflow-hidden md:h-[calc(100vh-theme(height.header-md)-2px)] h-[calc(100vh-theme(height.header))-2px] md:max-h-[calc(100vh-theme(height.header-md)-2px)] max-h-[calc(100vh-theme(height.header)-2px)];
    }
  }

  > .ant-layout-sider {
    @apply min-h-full overflow-hidden;

    .ant-layout-sider-children > div {
      @apply !grid h-full max-h-full grid-rows-[43px_1fr_auto] md:grid-rows-[60px_minmax(100px,1fr)_auto];
      div {
        @apply md:max-w-[260px];
      }

      .flex-grow {
        @apply overflow-y-auto;
      }
    }
  }
}
</style>
